<template>
  <el-dialog :close-on-press-escape="false" :show-close="false" :close-on-click-modal="false" class="baseinfo" :title="name + $t('componentsShiftchoose.hello')" :append-to-body="true" :visible.sync="shiftDialogShow" width="400px">
    <div class="label-title">{{ $t('common.currentBusinessDay') }}</div>
    <div class="bussinessday">{{ businessDay }}</div>
    <div class="label-title">{{ $t('componentsShiftchoose.pleaseSelectFlightSchedule') }}</div>
    <div class="turns-wrapper" :class="{ longlength: shiftList.length > 3 }">
      <div v-for="item in shiftList" v-show="item.endTime && item.startTime" :key="item.code" class="turns-block" @click="baseInfoChange(item)">
        <div class="flex-center">
          {{ item.name }}
          <el-popover v-if="item.reason" placement="bottom-start" width="156" trigger="hover" popper-class="tip-popperClass" :content="item.reason">
            <img slot="reference" class="icon-tip" src="@/assets/tip-icon.png" alt />
          </el-popover>
        </div>
        <div class="turn-time">{{ item.startTime }}-{{ item.endTime }}</div>
        <img v-show="shiftsObj && shiftsObj.name === item.name" class="icon-room-selected" src="@/assets/icon-room-selected.png" alt />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="ok-btn" type="primary" style="margin-right: 0;" @click="handleOkBtn">{{ $t('common.ok') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { setTurns, getCurrentUserShift } from '@/api/systemSet';
import { parseTime, getDate, helpJsonParse } from '@/utils/index';
import { mapGetters } from 'vuex';
import { queryFmiscustomSubjectDetail } from '@/api/fmis';
export default {
  name: 'ShiftChoose',
  data() {
    return {
      shiftDialogShow: false,
      shiftList: [],
      shiftsObj: undefined,
    };
  },
  computed: {
    ...mapGetters(['name', 'businessDay', 'hotelCode', 'userShifts', 'userId', 'isNeedRefreshBusinessDay', 'socketMessage']),
  },
  watch: {
    // 监听是否需要刷新营业日
    isNeedRefreshBusinessDay(value) {
      if (value) {
        this.getBaseInfo(true); // 得到营业日班次信息
        this.$store.commit('app/SET_REFRESH', false);
      }
    },
    socketMessage(resData) {
      try {
        const { type, childrenType, context = '' } = resData;
        if (type === 'socket' && childrenType === 'userShiftInfo') {
          const { hotelCode = '', userId = '', shiftsCode = '', shiftsName = '' } = helpJsonParse(context || null) || {};
          // 判断是同一个人并且是通过一个酒店
          if (+hotelCode === +this.hotelCode && +this.userId === +userId) {
            if (this.userShifts && shiftsCode !== this.userShifts.code) {
              // 班次不一致
              this.$store.commit('user/SET_SHIFTS', {
                data: { code: shiftsCode, name: shiftsName },
                isSetLocalStorage: true,
              });
            }
          }
        }
      } catch (error) {
        console.log('sokcet解析异常', error);
      }
    },
    userShifts(value) {
      if (value) {
        this.shiftDialogShow = false;
        this.shiftsObj = undefined;
      } else {
        this.getBaseInfo();
      }
    },
    hotelCode(value, oldValue) {
      if (value && !oldValue) {
        this.getBaseInfo();
      }
    },
  },
  methods: {
    async getBaseInfo(isNoNeedReSelect) {
      const currentTime = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}');
      const hotelForm = await this.$store.dispatch('user/getHotelType');
      const { shifts = [], orderVoiceCreate, orderVoiceCancel, businessDay, fulldayCheckoutVoiceNotify, hourCheckoutVoiceNotify } = await this.getBaseInfoSetting();
      if (this.taxMode) {
        try {
          let res = await queryFmiscustomSubjectDetail({ subjectCode: 200 });
          let obj = res.data.taxFieldVos.find((item) => item.businessFeeType === 0) || {};
          if (obj.businessFeeUnit === 1) {
            obj.amount = Number(obj.amount) * 100;
          }
          this.$store.commit('user/SET_TAX_CONFIG', obj);
        } catch (error) {
          console.log(error);
        }
      }
      this.$store.commit('user/SET_OREDER_NOTICE', orderVoiceCreate);
      this.$store.commit('user/SET_OREDER_CANCEL_NOTICE', orderVoiceCancel);
      this.$store.commit('user/SET_DAY_CHECKOUT_NOTICE', fulldayCheckoutVoiceNotify);
      this.$store.commit('user/SET_HOUR_CHECKOUT_NOTICE', hourCheckoutVoiceNotify);
      const currentUserShit = helpJsonParse(localStorage.getItem('userShifts'));
      if (hotelForm === 'qz' && !isNoNeedReSelect) {
        const { userId, shiftsCode, hotelCode, businessDay: oldBusinessDay } = (await this.getCurrentUserShift()) || {};
        if (!currentUserShit || !shiftsCode || this.businessDay !== businessDay) {
          this.shiftDialogShow = true;
          this.shiftsObj = undefined;
        } else if (currentUserShit && (currentUserShit.code !== shiftsCode || businessDay != oldBusinessDay || this.userId != userId) && this.hotelCode == hotelCode) {
          // 如果已经存在班次
          this.shiftDialogShow = true;
          this.shiftsObj = undefined;
        }
      } else if (hotelForm !== 'qz') {
        this.shiftDialogShow = true;
        this.shiftsObj = undefined;
      }
      if (shifts.every((item) => !item.startTime && !item.endTime)) {
        this.shiftList = [
          {
            code: 'morningShift',
            name: this.$t('common.morningShift2'),
            startTime: '--',
            endTime: '--',
          },
          {
            code: 'noonShift',
            name: this.$t('common.middleShift2'),
            startTime: '--',
            endTime: '--',
          },
          {
            code: 'nightShift',
            name: this.$t('common.nightShift2'),
            startTime: '--',
            endTime: '--',
          },
        ];
      } else {
        this.shiftList = shifts;
      }
      for (const item of this.shiftList) {
        if (this.compareTime(currentTime, item.startTime, item.endTime)) {
          this.shiftsObj = item;
          break;
        }
      }
      this.$store.commit('user/SET_SHIFTS_LIST', this.shiftList);
      this.$store.commit('user/SET_BUSINESS_DAY', businessDay);
    },
    compareTime(currentTime, startTime, endTime) {
      const today = parseTime(new Date(), '{y}-{m}-{d}');
      const nowTime = parseTime(new Date(), '{h}:{i}');
      let isColDay = false;
      if (startTime >= endTime) {
        isColDay = true;
        endTime = `${getDate(1)} ${endTime}`;
      } else {
        endTime = `${today} ${endTime}`;
      }
      startTime = `${today} ${startTime}`;
      if (isColDay) {
        // 如果咵天
        if (nowTime >= '12:00') {
          const end = parseTime(new Date(endTime), '{h}:{i}');
          if (end > '12:00') {
            if (parseTime(new Date(startTime), '{h}:{i}') <= '12:00') {
              return nowTime <= end;
            } else {
              currentTime = `${getDate(1)} ${nowTime}`;
            }
          }
          return currentTime >= startTime && currentTime <= endTime;
        } else {
          if (parseTime(new Date(startTime), '{h}:{i}') >= '12:00') {
            currentTime = `${getDate(1)} ${nowTime}`;
            return currentTime >= startTime && currentTime <= endTime;
          } else {
            return currentTime >= startTime && currentTime <= endTime;
          }
        }
      } else {
        return currentTime >= startTime && currentTime <= endTime;
      }
    },
    baseInfoChange(item) {
      this.shiftsObj = item;
    },
    handleOkBtn() {
      if (!this.shiftsObj) {
        return this.$message.warning(this.$t('componentsShiftchoose.pleaseSelectFlightSchedule'));
      }
      const { code: shiftsCode, name, startTime, endTime } = this.shiftsObj;

      const shiftsNameMap = {
        morningShift: '早班',
        noonShift: '中班',
        nightShift: '晚班',
        earlyMorningShift: '凌晨班',
      };

      const shiftsName = shiftsNameMap[shiftsCode] || this.shiftsObj.name;

      setTurns({
        shiftsCode,
        shiftsName,
        startTime,
        endTime,
        businessDay: this.businessDay,
      }).then((res) => {
        if (res.code === '0') {
          if (!res.msg.includes(this.$t('common.success')) && res.msg != 'success') {
            this.$message.warning(res.msg);
          }
          this.$store.commit('user/SET_SHIFTS', {
            data: { code: shiftsCode, name },
            isSetLocalStorage: true,
          });
          this.shiftsObj = undefined;
          this.$store.commit('user/SET_GLOBAL_TIP', true);
        }
      });
    },
    handleTime(time, number) {
      if (!time) {
        return;
      }
      if (time === '00:00') {
        time = '23:59';
      }
      return this.formateTimeStr(time, number).split(':')[0];
    },
    formateTimeStr(timeStr, number) {
      const tempTime = new Date(`${parseTime(new Date(), '{y}-{m}-{d}')} ${timeStr}`);
      tempTime.setHours(tempTime.getHours(), number);
      return parseTime(tempTime, '{h}:{i}');
    },
    initTurns(turnList) {
      const currentHourTime = parseTime(new Date(), '{h}:{i}');
      const REMAIN_TIME = 1;
      const currentTurnsIndex = turnList.findIndex((item) => currentHourTime >= item.startTime && currentHourTime <= (item.endTime === '00:00' ? '23:59' : item.endTime));
      if (currentTurnsIndex >= 0) {
        const { startTime, endTime } = turnList[currentTurnsIndex];
        this.shiftsObj = turnList[currentTurnsIndex];
        const start1 = this.handleTime(startTime, -Math.abs(REMAIN_TIME));
        const start2 = this.handleTime(startTime, REMAIN_TIME);
        const end1 = this.handleTime(endTime, -Math.abs(REMAIN_TIME));
        const end2 = this.handleTime(endTime, REMAIN_TIME);
        if (currentHourTime >= start1 && currentHourTime < start2) {
          return turnList.slice(currentTurnsIndex - REMAIN_TIME, currentTurnsIndex + REMAIN_TIME);
        } else if (currentHourTime > start2 && currentHourTime <= end1) {
          return [turnList[currentTurnsIndex]];
        } else if (currentHourTime > end1 && end2) {
          return turnList.slice(currentTurnsIndex, currentTurnsIndex + (REMAIN_TIME + 1));
        }
      }
    },
    // 获取当前的班次
    getCurrentUserShift() {
      return new Promise((resolve) => {
        getCurrentUserShift()
          .then((res) => {
            if (res.code === '0') {
              resolve(res.data);
            }
          })
          .catch(() => {
            resolve();
          });
      });
    },
  },
};
</script>
<style>
.tip-popperClass {
  padding: 8px 12px;
  color: #4f5161;
  font-size: 12px;
}
</style>
<style lang="scss" scoped>
.icon-tip {
  width: 12px;
  height: 12px;
  margin-left: 6px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
  user-select: none;
}
.label-title {
  color: rgba(123, 124, 137, 1);
  font-size: 14px;
  font-weight: 600;
}
.bussinessday {
  color: #4f5161;
  margin: 15px 0 32px 0;
}
.turns-wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  &:after {
    content: '';
    display: block;
    flex: 1;
  }
  &.longlength {
    .turns-block {
      &:nth-last-of-type(1) {
        margin-left: 2px;
        margin-top: 16px;
      }
    }
  }
  .turns-block {
    position: relative;
    width: 100px;
    font-weight: 600;
    padding: 16px 0 16px 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 10px 0px rgba(4, 88, 151, 0.06);
    border-radius: 2px;
    border: 1px solid rgba(0, 104, 182, 0.2);
    font-size: 14px;
    color: #23253a;
    margin-left: 18px;
    cursor: pointer;
    .turn-time {
      color: rgba(123, 124, 137, 1);
      font-size: 12px;
      margin-top: 8px;
    }
    &:nth-of-type(1) {
      margin-left: 0;
    }
    .icon-room-selected {
      width: 15px;
      height: 16px;
      position: absolute;
      right: -1px;
      bottom: -1px;
    }
  }
}
</style>
